var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"min-width":"1200px","min-height":"700px"},attrs:{"id":"metric-chart"}},[_c('p',[_vm._v("Metric Chart: "+_vm._s(_vm.metricCSVName))])]),_c('v-row',[_c('vue-json-to-csv',{attrs:{"json-data":_vm.metricCSV,"csv-title":_vm.metricCSVName}},[_c('v-btn',[_vm._v(" Download as CSV ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }